__turbopack_context__.v({
  "body": "XbRJIq_body",
  "slide": "XbRJIq_slide",
  "track": "XbRJIq_track",
  "viewport": "XbRJIq_viewport",
});
